<template>
  <header class="app-header">
    <div class="header-left">
      <div class="logo">
        <i class="el-icon-s-platform logo-icon"></i>
        <span class="logo-text">能碳管理平台</span>
      </div>
    </div>
    <div class="header-center">
      <el-menu
        :default-active="activeTopMenu"
        mode="horizontal"
        background-color="#1a3a5c"
        text-color="#b3c5d7"
        active-text-color="#ffffff"
        @select="handleTopMenuSelect"
      >
        <el-menu-item
          v-for="item in topMenus"
          :key="item.key"
          :index="item.path"
        >
          {{ item.title }}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="header-right">
      <el-avatar :size="28" icon="el-icon-user-solid"></el-avatar>
      <span class="user-name">{{ userInfo.name }}</span>
      <i class="el-icon-setting header-icon"></i>
      <i class="el-icon-switch-button header-icon" @click="handleLogout"></i>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { sidebarMenus, visibleTopMenus } from '@/config/menus'

export default {
  name: 'AppHeader',
  data() {
    return {
      topMenus: visibleTopMenus
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    activeTopMenu() {
      const matched = this.topMenus.find(item => this.$route.path.startsWith(item.path))
      return matched ? matched.path : this.topMenus[0].path
    }
  },
  methods: {
    handleTopMenuSelect(path) {
      const menu = this.topMenus.find(item => item.path === path)
      if (menu) {
        this.$store.commit('app/SET_CURRENT_MODULE', menu.key)
        const firstChild = sidebarMenus[menu.key] && sidebarMenus[menu.key][0]
        this.$router.push(firstChild ? firstChild.path : path)
      }
    },
    handleLogout() {
      this.$message.info('退出登录（Mock）')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.app-header {
  display: flex;
  align-items: center;
  height: @header-height;
  background: @primary-color;
  padding: 0 16px;
  flex-shrink: 0;
}

.header-left {
  width: 180px;
  flex-shrink: 0;

  .logo {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;

    .logo-icon {
      font-size: 22px;
    }

    .logo-text {
      font-size: 16px;
      font-weight: 600;
      white-space: nowrap;
    }
  }
}

.header-center {
  flex: 1;
  overflow: hidden;

  /deep/ .el-menu {
    border-bottom: none;
    height: @header-height;

    .el-menu-item {
      height: @header-height;
      line-height: @header-height;
      border-bottom: none !important;
      font-size: 13px;
      padding: 0 14px;

      &.is-active {
        background: rgba(64, 158, 255, 0.3) !important;
        color: #fff !important;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.08) !important;
      }
    }
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  flex-shrink: 0;

  .user-name {
    font-size: 13px;
  }

  .header-icon {
    font-size: 18px;
    cursor: pointer;
    opacity: 0.85;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
